export default __webpack_public_path__ + "static/media/ac.9b357fa3.svg";